import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/cells.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/checkmarkBadgeOutline.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/legalDocument.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/safe.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/userAccount.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/userQuestion.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/common/Accordion.tsx");
